import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants";
import { utilService } from "../../services/utilService";
import { RespUnitDeptListModel, unitDeptListResultInterface } from "./UnitDept.modal";

const getUnitListData = async (
  searchInput: any,
  params: any
): Promise<any> => {

  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/global-units-and-departments-list/?reg_code=${utilService.getNetwork()}&search_name=${searchInput}&type=2`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unitListResp = res as any;
      const result: any = {
        isSuccess: true,
        unitListResult: unitListResp.result,
        status: unitListResp.status,
        message: unitListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getUnitDeptListData = async (): Promise<unitDeptListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/list/?reg_code=${utilService.getNetwork()}`,
      getParams(),
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unitDeptListResp = res as RespUnitDeptListModel;
      const unitListResponse = setUnitListModel(unitDeptListResp);
      const deptListResponse = setDeptListModel(unitDeptListResp);
      const result: unitDeptListResultInterface = {
        isSuccess: true,
        unitListResult: unitListResponse,
        deptListResult: deptListResponse,
        status: unitDeptListResp.status,
        message: unitDeptListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: unitDeptListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getDeptListData = async (
  searchInput: any,
  params: any
): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/global-units-and-departments-list/?reg_code=${utilService.getNetwork()}&search_name=${searchInput}&type=1`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unitDeptListResp = res as any;
      const result: any = {
        isSuccess: true,
        unitListResult: unitDeptListResp.result,
        status: unitDeptListResp.status,
        message: unitDeptListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getUnitandDepartmentFavouriteList = async (params:any,siteId:number) =>{
    const respApiResult = await apiService
      .apiCall(
        `sboard/unit/list/?reg_code=${utilService.getNetwork()}&siteId=${siteId}`,
        params,
        apiServiceConstants.POST,
        utilService.getDeviceType()
      )

      .then((res) => {
        const userListResp = res as any;
        const result: any = {
          isSuccess: true,
          status: userListResp.status,
          message: userListResp.message,
          result:userListResp.result,
        }
        return result;
      })
      .catch((err) => {
        const result: any = {
          isSuccess: false,
          message: err.message,
          status: err.status,
        };
        return result;
      });
     return respApiResult;
}

const getSiteFavouriteList = async (params:any,siteId:number) =>{
  
  const respApiResult = await apiService
    .apiCall(
      `sboard/hospital/list/?reg_code=${utilService.getNetwork()}&siteId=${siteId}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: true,
        status: userListResp.status,
        message: userListResp.message,
        result:userListResp.result,
      }
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
   return respApiResult;
}

const setUnitListModel = (payload: any): any => {
  let UnitListArray = payload.result?.[0]?.unitList.map((object: any) => {
    return {
      id: object.unitId,
      name: object.unitName,
      location: object.location,
      type: object.type,
      fav: object.fav,
      site: object.site,
      contactDetails: object.contactDetails,
    };
  });
  return UnitListArray;
};

const setDeptListModel = (payload: any): any => {
  let UnitListArray = payload.result?.[0]?.departmentList.map((object: any) => {
    return {
      id: object.unitId,
      name: object.unitName,
      location: object.location,
      type: object.type,
      fav: object.fav,
      site: object.site,
      contactDetails: object.contactDetails,
    };
  });
  return UnitListArray;
};

const getParams = () => {
  return {
    siteId: getSiteId(),
    reg_code: utilService.getNetwork(),
  };
};

const getSiteId = () => {
  const url = window.location.pathname.split("/");
  return url[2];
};

const handleErrorResponse = () => {};

export const unitDeptListService = {
  getUnitDeptListData,
  getUnitListData,
  getDeptListData,
  handleErrorResponse,
  setUnitListModel,
  setDeptListModel,
  getUnitandDepartmentFavouriteList,
  getSiteFavouriteList
};
